export default "__VITE_ASSET__C2cCGRr___";